const t = {
  CONTENT_TYPE: "content-type",
  CONTENT_DISPOSITION: "content-disposition",
  AUTHORIZATION: "Authorization",
  MB_APP_CONTEXT: "X-MB-APP-CONTEXT"
};
class e {
  getHeaders() {
    return { ...t };
  }
}
const n = new e();
export {
  n as default
};
